import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import Text from '../../../Text'
import { $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'

function GetFasterTestimonials({
  eyebrow,
  title,
  testimonials = []
}) {
  const getPosition = (index, total) => {
    if (total <= 1) return 'center'
    if (index === 0) return 'left'
    if (index === total - 1) return 'right'
    return 'center'
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.header}>
          {eyebrow && <Text type="heading-8" color={$textTertiary.dark}>{eyebrow}</Text>}
          {title && (
            <h2 className={styles.title}>
              <SimpleBlockContent blocks={title} />
            </h2>
          )}
        </div>

        <div className={styles.testimonialsGrid}>
          {testimonials.map((testimonial, index) => {
            const isCenter = getPosition(index, testimonials.length) === 'center'
            return (
              <div
                key={index}
                className={isCenter ? `${styles.testimonialCard} ${styles.testimonialCardCenter}` : styles.testimonialCard}
              >
                <div className={isCenter ? `${styles.quoteMark} ${styles.quoteMarkCenter}` : styles.quoteMark}>
                  {/* eslint-disable-next-line local-rules/no-raw-media-src, local-rules/prefer-img-component -- TODO(#67): decorative static-public quote-mark SVG (Next /public), hand-sized 80x80; not resolver-managed content media */}
                  <img src="/images/get-faster/quote-icon.svg" alt="" width="80" height="80" />
                </div>
                <div className={styles.quoteText}><Text type="regular" color={$textTertiary.dark}>{testimonial.quote}</Text></div>
                <div className={styles.authorInfo}>
                  <span className={styles.authorName}><Text type="heading-8" color={$textTertiary.dark}>{testimonial.authorName}</Text></span>
                  {testimonial.authorTitle && (
                    <span className={styles.authorTitle}><Text type="small" color={$textTertiary.dark}>{testimonial.authorTitle}</Text></span>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default GetFasterTestimonials
